// https://jsperf.com/innerhtml-vs-removechild

export default node => {
  while (node && node.firstChild) {
    node.removeChild(node.firstChild);
  }
};
